import { BuilderActionType } from './enums';
import { BuilderAction, BuilderState } from './interfaces';

export const initialState: BuilderState = {
	cabinet: {
		width: 0,
		height: 0,
		depth: 0,
		productId: '',
		carcassThickness: 0,
		carcassCore: '',
		carcassInnerFinish: '',
		carcassOuterFinish: '',
		shutterThickness: 0,
		shutterCore: '',
		shutterInnerFinish: '',
		shutterOuterFinish: '',
		backPanel: '',
		exposedPanel: '',
		hardwareMaterials: [],
		cabinetFixtures: '',
		cncType: '',
		handles: '',
		handleCap: '',
		cncArea: 0,
		cncWidth: 0,
		cncHeight: 0,
		carcassPrice: 0,
		shutterPrice: 0,
		carcassEdgeBandingPrice: 0,
		shutterEdgeBandingPrice: 0,
		installationPrice: 0,
		handlesPrice: 0,
		hardwarePrice: 0,
		hardwareConnectorsPrice: 0,
		hardwareConnectors: [],
		cncPrice: 0,
		mwoPrice: 0
	},
	cutlist: [
		{
			name: '',
			type: '',
			material: '',
			finishingHeight: 0,
			finishingWidth: 0,
			cuttingHeight: 0,
			cuttingWidth: 0,
			quantity: 0,
			edgeBanding1: {
				h1: '',
				h2: '',
				w1: '',
				w2: ''
			},
			data: {
				a: 0,
				b: 0
			},
			edgeBanding2: {
				h1: '',
				h2: '',
				w1: '',
				w2: ''
			}
		}
	],
	error: null,
	countertopTotal: 0,
	countertop: {},
	fcBuilderData: {},
	fcBuilderDataLoading: false,
	loft: {},
	loftLoading: false,
	loftCutlist: [],
	countertopLoading: false,
	cabinetLoading: false,
	wallPanel: {
		productId: '',
		width: 0,
		height: 0,
		panelBoard: '',
		panelInnerFinish: '',
		panelOuterFinish: '',
		cncType: '',
		cncArea: 0,
		panelPrice: 0,
		cncPrice: 0,
		factoryProductionPrice: 0,
		labourPrice: 0,
		installationPrice: 0,
		transportationPrice: 0,
		consumablesPrice: 0,
		backLightPrice: 0,
		wastagePrice: 0,
		marginPrice: 0,
		gstPrice: 0,
		totalPrice: 0,
		backLight: false,
		boxPaneling: false,
		boxPanelingType: 'PLY_STYLE',
		boxPanelingPrice: 0,
		lightingEnabled: false,
		lightingRunningFeet: 0,
		lightingMaterial: null,
		flutedPanelMaterial: null,
		flutedCustomMaterial: null,
		wallPanelType: '',
		panelingType: '',
		orientation: ''
	},
	wallPanelLoading: false,
	wallPanelCalculation: {},
	wardrobe: {},
	wardrobeLoading: false,
	wardrobeCalculation: {},
	wardrobeCutlist: [],
	electricalCalculation: {},
	electricalCalculationLoading: false,
	electricalCalculationError: null,
	projectElectricalState: [],
	projectElectricalStateLoading: false,
	projectElectricalStateError: null,
	paintBuilderState: {},
	paintBuilderStateLoading: false,
	paintBuilderStateError: null,
	paintBuilderCalculationLoading: false,
	allBuilderStates: null,
	allBuilderStatesLoading: false,
	allBuilderStatesError: null,
	mouldingState: {},
	mouldingStateLoading: false,
	mouldingStateError: null,
	mouldingCalculationLoading: false,
	wallMoulding: {},
	wallMouldingLoading: false,
	paintBuilder: {},
	paintBuilderLoading: false,
	drawer: {},
	drawerLoading: false,
	drawerCalculation: {},
	drawerCutlist: {},
	ledge: {},
	ledgeLoading: false,
	ledgeCalculation: {},
	curtainBuilderState: {},
	curtainBuilderStateLoading: false,
	curtainBuilderStateError: null,
	curtainBuilderCalculation: {},
	curtainBuilderCalculationLoading: false,
	curtainBuilderCalculationError: null,
	ledgeCutlist: {},
	builderPreview: { activeProductId: null, pendingChanges: null }
};

export default (state = initialState, { type, payload }: BuilderAction): BuilderState => {
	switch (type) {
		case BuilderActionType.FETCH_CABINET_STATE: {
			return {
				...state
			};
		}

		case BuilderActionType.STORE_CABINET_STATE: {
			return {
				...state,
				cabinet: payload.cabinet
			};
		}

		case BuilderActionType.UPDATE_CABINET_STATE: {
			return {
				...state,
				cabinet: {
					...state.cabinet,
					...payload.cabinet
				}
			};
		}

		case BuilderActionType.ERROR_CABINET_STATE: {
			return {
				...state,
				error: payload.error
			};
		}

		case BuilderActionType.FETCH_CABINET_CUTLIST: {
			return {
				...state
			};
		}

		case BuilderActionType.STORE_CABINET_CUTLIST: {
			return {
				...state,
				cutlist: payload.cutlist
			};
		}

		case BuilderActionType.UPDATE_CABINET_CUTLIST: {
			return {
				...state,
				cutlist: payload.cutlist
			};
		}

		case BuilderActionType.ERROR_CABINET_CUTLIST: {
			return {
				...state,
				error: payload.error
			};
		}

		case BuilderActionType.STORE_COUNTER_TOP_CALCULATION: {
			return {
				...state,
				countertopTotal: payload
			};
		}

		case BuilderActionType.STORE_COUNTER_TOP_STATE: {
			return {
				...state,
				countertop: payload,
				countertopLoading: false
			};
		}

		case BuilderActionType.FETCH_COUNTER_TOP_STATE: {
			return {
				...state,
				countertop: {},
				countertopLoading: true
			};
		}

		case BuilderActionType.ERROR_COUNTER_TOP_STATE: {
			return {
				...state,
				error: payload?.error ?? null,
				countertopLoading: false
			};
		}

		case BuilderActionType.FETCH_LOFT_STATE: {
			return {
				...state,
				loftLoading: true
			};
		}

		case BuilderActionType.STORE_LOFT_STATE: {
			return {
				...state,
				loft: payload?.loft ?? payload,
				loftLoading: false
			};
		}

		case BuilderActionType.ERROR_LOFT_STATE: {
			return {
				...state,
				error: payload?.error ?? null,
				loftLoading: false
			};
		}

		case BuilderActionType.FETCH_LOFT_CUTLIST: {
			return {
				...state,
				loftLoading: true
			};
		}

		case BuilderActionType.STORE_LOFT_CUTLIST: {
			return {
				...state,
				loftCutlist: payload.cutlist,
				loftLoading: false
			};
		}

		case BuilderActionType.ERROR_LOFT_CUTLIST: {
			return {
				...state,
				error: payload?.error ?? null,
				loftLoading: false
			};
		}

		case BuilderActionType.FETCH_BUILDER_FC_DATA: {
			return {
				...state,
				fcBuilderDataLoading: true
			};
		}

		case BuilderActionType.STORE_BUILDER_FC_DATA: {
			return {
				...state,
				fcBuilderDataLoading: false,
				fcBuilderData: payload
			};
		}

		case BuilderActionType.FETCH_WALL_PANEL_STATE: {
			return {
				...state,
				wallPanelLoading: true
			};
		}

		case BuilderActionType.STORE_WALL_PANEL_STATE: {
			return {
				...state,
				wallPanelLoading: false,
				wallPanel: payload
			};
		}

		case BuilderActionType.ERROR_WALL_PANEL_STATE: {
			return {
				...state,
				wallPanelLoading: false
			};
		}

		case BuilderActionType.STORE_WALL_PANEL_CALCULATION: {
			return {
				...state,
				wallPanelCalculation: payload
			};
		}

		case BuilderActionType.STORE_WARDROBE_STATE: {
			return {
				...state,
				wardrobe: payload.wardrobe,
				wardrobeLoading: false
			};
		}

		case BuilderActionType.FETCH_WARDROBE_STATE: {
			return {
				...state,
				wardrobeLoading: true
			};
		}

		case BuilderActionType.ERROR_WARDROBE_STATE: {
			return {
				...state,
				wardrobeLoading: false,
				error: payload.error
			};
		}

		case BuilderActionType.STORE_WARDROBE_CALCULATION: {
			return {
				...state,
				wardrobeCalculation: payload.wardrobeCalculation
			};
		}

		case BuilderActionType.STORE_WARDROBE_CUTLIST: {
			return {
				...state,
				wardrobeCutlist: payload.wardrobeCutlist
			};
		}

		case BuilderActionType.STORE_ELECTRICAL_CALCULATION: {
			return {
				...state,
				electricalCalculation: payload
			};
		}

		case BuilderActionType.FETCH_PROJECT_ELECTRICAL_STATE: {
			return {
				...state,
				projectElectricalStateLoading: true
			};
		}

		case BuilderActionType.STORE_PROJECT_ELECTRICAL_STATE: {
			return {
				...state,
				projectElectricalStateLoading: false,
				projectElectricalState: payload
			};
		}

		case BuilderActionType.ERROR_PROJECT_ELECTRICAL_STATE: {
			return {
				...state,
				projectElectricalStateLoading: false,
				projectElectricalStateError: payload.error
			};
		}

		case BuilderActionType.FETCH_PAINT_BUILDER_STATE: {
			return {
				...state,
				paintBuilderStateLoading: true,
				paintBuilderLoading: true
			};
		}

		case BuilderActionType.STORE_PAINT_BUILDER_STATE: {
			return {
				...state,
				paintBuilderStateLoading: false,
				paintBuilderState: payload,
				paintBuilderLoading: false,
				paintBuilder: payload
			};
		}

		case BuilderActionType.ERROR_PAINT_BUILDER_STATE: {
			return {
				...state,
				paintBuilderStateLoading: false,
				paintBuilderStateError: payload.error
			};
		}

		case BuilderActionType.FETCH_PAINT_BUILDER_CALCULATION: {
			return {
				...state,
				paintBuilderCalculationLoading: true
			};
		}

		case BuilderActionType.STORE_PAINT_BUILDER_CALCULATION: {
			return {
				...state,
				paintBuilderState: payload,
				paintBuilderCalculationLoading: false
			};
		}

		case BuilderActionType.ERROR_PAINT_BUILDER_CALCULATION: {
			return {
				...state,
				paintBuilderCalculationLoading: false
			};
		}

		case BuilderActionType.FETCH_ALL_BUILDER_STATES: {
			return {
				...state,
				allBuilderStatesLoading: true,
				allBuilderStatesError: null
			};
		}

		case BuilderActionType.STORE_ALL_BUILDER_STATES: {
			return {
				...state,
				allBuilderStatesLoading: false,
				allBuilderStates: payload
			};
		}

		case BuilderActionType.ERROR_ALL_BUILDER_STATES: {
			return {
				...state,
				allBuilderStatesLoading: false,
				allBuilderStatesError: payload?.error ?? null,
				error: payload?.error ?? null
			};
		}

		case BuilderActionType.FETCH_MOULDING_CALCULATION: {
			return {
				...state,
				mouldingCalculationLoading: true
			};
		}

		case BuilderActionType.STORE_MOULDING_CALCULATION: {
			return {
				...state,
				mouldingState: payload,
				mouldingCalculationLoading: false
			};
		}

		case BuilderActionType.ERROR_MOULDING_CALCULATION: {
			return {
				...state,
				mouldingCalculationLoading: false
			};
		}

		case BuilderActionType.FETCH_MOULDING_STATE: {
			return {
				...state,
				mouldingStateLoading: true
			};
		}

		case BuilderActionType.STORE_MOULDING_STATE: {
			return {
				...state,
				mouldingStateLoading: false,
				mouldingState: payload
			};
		}

		case BuilderActionType.ERROR_MOULDING_STATE: {
			return {
				...state,
				mouldingStateLoading: false,
				mouldingStateError: payload.error
			};
		}

		case BuilderActionType.FETCH_WALL_MOULDING_STATE: {
			return {
				...state,
				wallMouldingLoading: true
			};
		}

		case BuilderActionType.STORE_WALL_MOULDING_STATE: {
			return {
				...state,
				wallMouldingLoading: false,
				wallMoulding: payload
			};
		}

		case BuilderActionType.ERROR_WALL_MOULDING_STATE: {
			return {
				...state,
				wallMouldingLoading: false,
				error: payload?.error ?? null
			};
		}

		// Drawer Builder
		case BuilderActionType.FETCH_DRAWER_STATE: {
			return {
				...state,
				drawerLoading: true
			};
		}

		case BuilderActionType.STORE_DRAWER_STATE: {
			return {
				...state,
				drawer: payload?.drawer ?? payload,
				drawerLoading: false
			};
		}

		case BuilderActionType.ERROR_DRAWER_STATE: {
			return {
				...state,
				drawerLoading: false,
				error: payload?.error ?? null
			};
		}

		case BuilderActionType.STORE_DRAWER_CALCULATION: {
			return {
				...state,
				drawerCalculation: payload
			};
		}

		case BuilderActionType.STORE_DRAWER_CUTLIST: {
			return {
				...state,
				drawerCutlist: payload
			};
		}

		case BuilderActionType.ERROR_DRAWER_CALCULATION: {
			return {
				...state,
				error: payload?.error ?? null
			};
		}

		case BuilderActionType.ERROR_DRAWER_CUTLIST: {
			return {
				...state,
				error: payload?.error ?? null
			};
		}

		// Ledge Builder
		case BuilderActionType.FETCH_LEDGE_STATE: {
			return {
				...state,
				ledgeLoading: true
			};
		}

		case BuilderActionType.STORE_LEDGE_STATE: {
			return {
				...state,
				ledge: payload?.ledge ?? payload,
				ledgeLoading: false
			};
		}

		case BuilderActionType.ERROR_LEDGE_STATE: {
			return {
				...state,
				ledgeLoading: false,
				error: payload?.error ?? null
			};
		}

		case BuilderActionType.STORE_LEDGE_CALCULATION: {
			return {
				...state,
				ledgeCalculation: payload
			};
		}

		case BuilderActionType.STORE_LEDGE_CUTLIST: {
			return {
				...state,
				ledgeCutlist: payload
			};
		}

		case BuilderActionType.ERROR_LEDGE_CALCULATION: {
			return {
				...state,
				error: payload?.error ?? null
			};
		}

		case BuilderActionType.ERROR_LEDGE_CUTLIST: {
			return {
				...state,
				error: payload?.error ?? null
			};
		}

		case BuilderActionType.FETCH_CURTAIN_BUILDER_STATE: {
			return {
				...state,
				curtainBuilderStateLoading: true
			};
		}

		case BuilderActionType.STORE_CURTAIN_BUILDER_STATE: {
			return {
				...state,
				curtainBuilderStateLoading: false,
				curtainBuilderState: payload
			};
		}

		case BuilderActionType.ERROR_CURTAIN_BUILDER_STATE: {
			return {
				...state,
				curtainBuilderStateLoading: false,
				curtainBuilderStateError: payload?.error ?? null
			};
		}

		case BuilderActionType.FETCH_CURTAIN_BUILDER_CALCULATION: {
			return {
				...state,
				curtainBuilderCalculationLoading: true
			};
		}

		case BuilderActionType.STORE_CURTAIN_BUILDER_CALCULATION: {
			return {
				...state,
				curtainBuilderCalculationLoading: false,
				curtainBuilderCalculation: payload
			};
		}

		case BuilderActionType.ERROR_CURTAIN_BUILDER_CALCULATION: {
			return {
				...state,
				curtainBuilderCalculationLoading: false,
				curtainBuilderCalculationError: payload?.error ?? null
			};
		}

		case BuilderActionType.SET_BUILDER_PREVIEW:
			return {
				...state,
				builderPreview: payload
			};

		case BuilderActionType.CLEAR_BUILDER_PREVIEW:
			return {
				...state,
				builderPreview: { activeProductId: null, pendingChanges: null }
			};

		default:
			return state;
	}
};
